import { createSelector } from '@reduxjs/toolkit';

export const app = (state) => state.app;
export const stats = createSelector(
  app,
  (appState) => appState.stats,
)
export const cityInfo = createSelector(
  stats,
  (statsData) => statsData?.cityInfo,
);

export const place = createSelector(
  cityInfo,
  (cityInfoData) => cityInfoData?.place,
);

export const flowsSelector = createSelector(
  stats,
  (statsData) => statsData?.flows,
);

export const activePaymentMethodTab = createSelector(
  app,
  (appState) => appState.activePaymentMethodTab,
);

// TODO: Consider moving this to selector in own flow
export const licenseFeeInfo = createSelector(
  app,
  (appState) => appState.licenseFeeInfo,
);

export const newLicenseInfo = createSelector(
  app,
  (appState) => appState.newLicenseInfo,
);

export const visitedFirstPageInFlow = createSelector(
  app,
  (appState) => appState.visitedFirstPageInFlow,
);
